<template lang="">
  <div
    v-if="
      user.permissions.indexOf(permissionsAll.rol_list) >= 0 ||
        user.person.types_person.id === 3
    "
  >
    <CardRoles />
  </div>
</template>
<script>
import CardRoles from "../../components/roles/CardRoles.vue";
import permissions from "../../helpers/permissions";
import { mapState } from "vuex";
export default {
  name: "RolesView",
  components: {
    CardRoles,
  },
  data() {
    return {
      permissionsAll: permissions,
    };
  },
  computed: {
    ...mapState(["user"]),
  },
};
</script>
<style lang=""></style>
